module.exports = __webpack_public_path__ + "img/F_04.96d4076b.gif";